var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.cubes.filter((x) =>
      x.availableProducts.includes(_vm.selectedTab)
    )),function(cube){return _c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(cube.show),expression:"cube.show"}],key:cube.id,staticClass:"white--text mx-1 my-1 fab-btn",attrs:{"fab":"","elevation":"0","color":cube.isActive ? 'red' : 'viortis'},on:{"click":function($event){return _vm.select(cube)}}},[_c('span',{staticClass:"text-caption"},[_vm._v(_vm._s(cube.name))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }